<div>
    <!-- Title -->
    <ngx-form-cell-header
        [fieldLabel]="field.label"
        [required]="fieldRequired"
        [countOfDeficiency]="countOfDeficiency"
        [cellType]="cellType"
        (onLeadIconClick)="onLeadIconClick.emit({fieldType: field.fieldType, fieldId: field.id})"
        (addDeficiency)="onAddDeficiencyClicked()"
    ></ngx-form-cell-header>
    <!-- Main content -->
    <ng-container *ngIf="cellType === FormCellType.PREVIOUS; else currentField">
        <nb-checkbox disabled [checked]="getFormValue()">Select</nb-checkbox>
    </ng-container>

    <ng-template #currentField [ngSwitch]="viewMode">
        <ng-container *ngSwitchCase="FormViewModeEnum.EDIT_RESULTS">
            <div>
                <nb-checkbox
                    [status]="fieldForm?.touched && fieldForm?.invalid ? 'danger' : 'basic'"
                    [formControl]="fieldForm"
                    (checkedChange)="checkedChange($event)"
                    class="edit-mode"
                >
                    Select
                </nb-checkbox>
            </div>
        </ng-container>

        <ng-container *ngSwitchCase="FormViewModeEnum.VIEW_RESULTS">
            <ng-container>
                <div class="row">
                    <div class="col-md-11">
                        <nb-checkbox [checked]="getFormValue()" disabled>Select</nb-checkbox>
                    </div>
                </div>
            </ng-container>
        </ng-container>

        <ng-container *ngSwitchCase="FormViewModeEnum.VIEW_CONFIG">
            <nb-checkbox disabled>Select</nb-checkbox>
        </ng-container>
    </ng-template>
</div>
